<template>
  <page-header-wrapper>
    <a-card :bordered='false'>
      <!-- 操作按钮区域 -->
      <div class='table-operations'>
        <!-- 新增按钮 -->
        <!-- v-hasPermi="['app:version/info:add']" -->
        <a-button type='primary' @click='$refs.createForm.handleAdd()'>
          <a-icon type='plus' />
          {{ $t('common.add') }}
        </a-button>
        <!-- 删除按钮 -->
        <!-- v-hasPermi="['app:version/info:remove']" -->
        <a-button type='danger' :disabled='multiple' @click='handleDelete'>
          <a-icon type='delete' />
          {{ $t('common.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync='tableSize'
          v-model='columns'
          :refresh-loading='loading'
          @refresh='getList' />
      </div>
      <!-- 新增/编辑表单组件 -->
      <create-form
        ref='createForm'
        @ok='getList'
      />
      <!-- 数据表格 -->
      <a-table
        :loading='loading'
        :size='tableSize'
        rowKey='id'
        :columns='columns'
        :data-source='list'
        :row-selection='{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }'
        :pagination='false'
        :bordered='tableBordered'
      >
        <!-- 操作列 -->
        <span slot='operation' slot-scope='text, record'>
          <!-- v-hasPermi="['app:version/info:edit']" -->
          <a @click='$refs.createForm.handleUpdate(record, undefined)'>
            <a-icon type='edit' />{{ $t('common.edit') }}
          </a>
          <!-- v-hasPermi="['app:version/info:remove']" -->
          <a-divider type='vertical' />
          <!-- v-hasPermi="['app:version/info:remove']" -->
          <a @click='handleDelete(record)'>
            <a-icon type='delete' />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class='ant-table-pagination'
        show-size-changer
        show-quick-jumper
        :current='queryParam.pageNum'
        :total='total'
        :page-size='queryParam.pageSize'
        :showTotal='total => $t("table.total", { total })'
        @showSizeChange='onShowSizeChange'
        @change='changeSize'
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVersionInfo, delVersionInfo } from '@/api/app/versionInfo'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'VersionInfo',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      // 数据列表
      list: [],
      // 表格选中的行keys
      selectedRowKeys: [],
      // 表格选中的行数据
      selectedRows: [],
      // 非多个禁用（用于批量删除按钮）
      multiple: true,
      // 选中的ID数组（用于批量删除）
      ids: [],
      // 加载状态
      loading: false,
      // 总记录数
      total: 0,
      // 查询参数
      queryParam: {
        appType: null,
        upNotes: null,
        upHeSize: null,
        upUrlType: null,
        upUrl: null,
        versionName: null,
        versionCode: null,
        upType: null,
        compulsoryUp: null,
        planUpType: null,
        planUpTime: null,
        downloadUrl: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  computed: {
    // 表格列配置
    columns() {
      return [
        {
          title: '#',
          dataIndex: 'id',
          align: 'center',
          customRender(text, record, index) {
            return index + 1
          }
        },
        {
          title: this.$t('appVersion.appType'),
          dataIndex: 'appType',
          align: 'center',
          customRender: (value) => {
            if (value == 0) {
              return this.$t('appVersion.android')
            } else if (value == 1) {
              return this.$t('appVersion.ios')
            }
          }
        },
        {
          title: this.$t('appVersion.versionName'),
          dataIndex: 'versionName',
          align: 'center'
        },
        {
          title: this.$t('appVersion.versionCode'),
          dataIndex: 'versionCode',
          align: 'center'
        },
        {
          title: this.$t('appVersion.packageSize'),
          dataIndex: 'upHeSize',
          align: 'center'
        },
        {
          title: this.$t('appVersion.updateUrlType'),
          dataIndex: 'upUrlType',
          align: 'center',
          customRender: (value) => {
            return value == 1 ? this.$t('appVersion.market') : this.$t('appVersion.internal')
          }
        },
        {
          title: this.$t('appVersion.updateType'),
          dataIndex: 'upType',
          align: 'center',
          customRender: (value) => {
            return value == 1 ? this.$t('appVersion.fullUpdate') : this.$t('appVersion.hotUpdate')
          }
        },
        {
          title: this.$t('appVersion.forceUpdate'),
          dataIndex: 'compulsoryUp',
          align: 'center',
          customRender: (value) => {
            return value == 1 ? this.$t('appVersion.canSkip') : this.$t('appVersion.force')
          }
        },
        {
          title: this.$t('appVersion.downloadUrl'),
          dataIndex: 'downloadUrl',
          align: 'center'
        },
        {
          title: this.$t('appVersion.updateNotes'),
          dataIndex: 'upNotes',
          align: 'center'
        },
        {
          title: this.$t('table.createTime'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    // 初始化：获取版本信息列表
    this.getList()
  },
  methods: {
    /**
     * 查询APP版本信息列表
     */
    getList() {
      this.loading = true
      pageVersionInfo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = Number(response.data.total)
        this.loading = false
      })
    },
    /**
     * 分页大小改变
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /**
     * 表格行选择变化
     * @param {Array} selectedRowKeys - 选中的行keys
     * @param {Array} selectedRows - 选中的行数据
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.multiple = !selectedRowKeys.length
    },
    /**
     * 删除操作
     * @param {Object} row - 行数据（单行删除时传入，批量删除时不传）
     */
    handleDelete(row) {
      const that = this
      // 确定要删除的ID数组
      let deleteIds = []
      if (row && row.id) {
        // 单行删除
        deleteIds = [row.id]
      } else {
        // 批量删除
        deleteIds = this.ids
      }

      if (deleteIds.length === 0) {
        this.$message.warning(this.$t('appVersion.selectDataToDelete'))
        return
      }

      this.$confirm({
        title: this.$t('appVersion.confirmDelete'),
        content: this.$t('appVersion.confirmDeleteContent') + deleteIds.join(','),
        onOk() {
          const data = deleteIds.map(id => ({ id: id }))
          return delVersionInfo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('common.deleteSuccess'), 3)
            })
        }
      })
    }
  }
}
</script>
